/**
 * 실행 환경 판별.
 *
 * 기본 배포는 Tauri 데스크톱 앱이다. 같은 프론트엔드가 브라우저와
 * 안드로이드·iOS 웹뷰에서도 돈다.
 */

export type Runtime = 'desktop' | 'mobile' | 'web';

/** Tauri 웹뷰(데스크톱 또는 모바일) 안에서 실행 중인지 */
export function isDesktop(): boolean {
  return typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;
}

export function isPhoneUa(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

/** 가상 패드를 띄울지. `?touch=1` 로 데스크톱 브라우저에서도 강제할 수 있다. */
export function wantsTouchPad(): boolean {
  if (typeof window === 'undefined') return false;
  if (new URLSearchParams(window.location.search).has('touch')) return true;
  if (isPhoneUa()) return true;
  return window.matchMedia('(pointer: coarse)').matches;
}

export function runtime(): Runtime {
  if (!isDesktop()) return 'web';
  return isPhoneUa() ? 'mobile' : 'desktop';
}

export const RUNTIME_LABEL: Record<Runtime, string> = {
  desktop: '데스크톱 앱',
  mobile: '모바일 앱',
  web: '브라우저',
};
